function upperCaseFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export {
    upperCaseFirst
};
